import { render, staticRenderFns } from "./GiftHistoryCardSkeleton.vue?vue&type=template&id=5988633f&scoped=true"
import script from "./GiftHistoryCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GiftHistoryCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./GiftHistoryCardSkeleton.vue?vue&type=style&index=0&id=5988633f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988633f",
  null
  
)

export default component.exports